// import { CLIENTS } from '@app/routes/pages/clientsPages/constants';

export const DUBLICATE_CLIENTS = 'duplicate-clients';
export const DUBLICATE_CLIENTS_LABEL = 'Дубликаты клиентов';
export const DUBLICATE_CLIENTS_PATH = '/clients/duplicates';
export const DUBLICATE_CLIENTS_SETTINGS = 'duplicate-clients-settings';
export const DUBLICATE_CLIENTS_SETTINGS_LABEL = 'Настройка дубликатов клиентов';
export const DUBLICATE_CLIENTS_SETTINGS_PATH = `${DUBLICATE_CLIENTS_PATH}/settings`;
